// extracted by mini-css-extract-plugin
export default {"brand":"Logo_brand__VBPwL","brandIcon":"Logo_brandIcon__Lhc6Z","brandText":"Logo_brandText__cyvKJ"};